import React from 'react'
import Chart from 'react-apexcharts'

function CommonChart({ options, series, type }) {
    return (
        <Chart options={options} series={series} type={type} />
    )
}

export default CommonChart
